import useSWR from "swr";

import PageNotFound from "../PageNotFound";
import PageLoadingMessage from "../../components/PageLoadingMessage";

const ContentPage = ({ slug }: { slug: string }) => {
  const { data, error } = useSWR("/api/content-pages/?slug=" + slug);

  const { content = "", name = "" } =
    data?.results.find((c) => c.slug === slug) ?? {};
  const contentTitle = name;

  const isLoading = !data && !error;

  if (isLoading) {
    return (
      <section className="section">
        <div className="container is-max-desktop">
          <PageLoadingMessage message="Loading" />
        </div>
      </section>
    );
  }

  // TODO: not necessary since SSR now
  if (!content) {
    return <PageNotFound />;
  }

  return (
    <>
      <section className="hero is-primary">
        <div className="hero-body">
          <div className="container is-max-desktop">
            <h1 className="title">{contentTitle}</h1>
          </div>
        </div>
      </section>
      <section className="section">
        <div
          className="container is-max-desktop content"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </section>
    </>
  );
};

export default ContentPage;
